import {
  PLACE_ORDER_SUCCESS,
  GET_ALL_ORDER_SUCCESS,
  GET_ORDER_SUCCESS,
  CLEAR_ORDER_RESULT
} from "../actions/types";
const initialState = {
  order: {},
  redirectUrl: "",
  orderslist: [],
  orderDetail: {}
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case PLACE_ORDER_SUCCESS:
      console.log("reducer", action);
      return {
        ...state,
        order: action.order.data,
        redirectUrl: action.order.redirectUrl
      };

    case GET_ALL_ORDER_SUCCESS:
      return {
        ...state,
        orderslist: action.orderslist
      };

    case GET_ORDER_SUCCESS:
      return {
        ...state,
        orderDetail: action.orderDetail
      };
    case CLEAR_ORDER_RESULT:
      return {
        ...state,
        order: {}
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/reducers/order.js